import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './Testimonials.css';

const reviews = [
  { initials:'PS', name:'Priya Sharma',    location:'Delhi',     dest:'Canada',     text:'RoamLife made my Canada tourist visa completely stress-free. Professional, responsive, and guided me at every step. Got my visa in just 18 days!' },
  { initials:'RM', name:'Rahul Mehta',     location:'Mumbai',    dest:'UK',         text:'Had a prior UK rejection, but RoamLife helped me reapply with a strong cover letter and proper docs. Approved this time. Highly recommend.' },
  { initials:'AK', name:'Ananya Krishnan', location:'Bangalore', dest:'Australia',  text:'Very professional team. Explained everything clearly and helped me prepare all documents for Australia. The process was smooth and timely.' },
  { initials:'VS', name:'Vikram Singh',    location:'Pune',      dest:'Germany',    text:'Thorough document review and a perfect travel itinerary for my Schengen visa. They know exactly what embassies look for. Worth every rupee.' },
  { initials:'SP', name:'Sunita Patel',    location:'Ahmedabad', dest:'Singapore',  text:'Quick and efficient Singapore eVisa — approved in 3 days. The team responded on WhatsApp immediately to every question I had.' },
  { initials:'AN', name:'Arun Nair',       location:'Chennai',   dest:'UAE',        text:'Used RoamLife for a UAE family trip. Seamless process, transparent pricing, no hidden charges. Great experience start to finish.' },
  { initials:'DG', name:'Deepika Gupta',   location:'Hyderabad', dest:'Thailand',   text:'They helped me with the TDAC form and all related docs for Thailand. Very patient with first-time travelers. Highly knowledgeable team.' },
  { initials:'MJ', name:'Mohit Joshi',     location:'Jaipur',    dest:'New Zealand',text:'End-to-end service for New Zealand visitor visa. Their checklist was incredibly helpful. Approved in 22 days. Truly professional.' },
];

export default function Testimonials() {
  const swiperRef = useRef(null);

  return (
    <section id="testimonials" className="sec sec-dark">
      <div className="container">

        {/* Header */}
        <div className="testi-header">
          <div>
            <p className="label"><i className="fas fa-star"></i> Client Reviews</p>
            <h2 className="sec-title">What Our <span>Clients Say</span></h2>
            <div className="rule"></div>
          </div>
          <div className="testi-meta">
            <div className="testi-score">
              <span className="testi-score-num">4.9</span>
              <div>
                <div className="testi-stars">
                  {[1,2,3,4,5].map(i => <i key={i} className="fas fa-star"></i>)}
                </div>
                <div className="testi-score-sub">Average Rating</div>
              </div>
            </div>
            <div className="testi-sep"></div>
            <div className="testi-count"><strong>1,200+</strong><span>Verified Reviews</span></div>
            <div className="testi-sep"></div>
            <div className="testi-count"><strong>98%</strong><span>Recommend Us</span></div>
          </div>
        </div>

        {/* Slider with side arrows */}
        <div className="testi-slider-wrap">

          {/* LEFT arrow */}
          <button
            className="testi-arr testi-arr-prev"
            onClick={() => swiperRef.current?.slidePrev()}
            aria-label="Previous"
          >
            <i className="fas fa-chevron-left"></i>
          </button>

          <Swiper
            modules={[Pagination]}
            onSwiper={swiper => { swiperRef.current = swiper; }}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            loop
            breakpoints={{
              640:  { slidesPerView: 1 },
              768:  { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="testi-swiper"
          >
            {reviews.map((r, i) => (
              <SwiperSlide key={i}>
                <div className="testi-card">
                  <div className="testi-quote-icon"><i className="fas fa-quote-left"></i></div>
                  <div className="testi-stars-row">
                    {[1,2,3,4,5].map(j => <i key={j} className="fas fa-star"></i>)}
                  </div>
                  <p className="testi-text">"{r.text}"</p>
                  <div className="testi-footer">
                    <div className="testi-avatar">{r.initials}</div>
                    <div>
                      <span className="testi-name">{r.name}</span>
                      <span className="testi-loc"><i className="fas fa-location-dot"></i>{r.location}</span>
                    </div>
                    <div className="testi-dest"><i className="fas fa-plane"></i>{r.dest}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* RIGHT arrow */}
          <button
            className="testi-arr testi-arr-next"
            onClick={() => swiperRef.current?.slideNext()}
            aria-label="Next"
          >
            <i className="fas fa-chevron-right"></i>
          </button>

        </div>
      </div>
    </section>
  );
}
